import { Container, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetQueueRoute } from "src/hooks/useGetQueueRoute";
import Lottie from "lottie-react";
import medicalClipboard from "src/lottie/medicalClipboard.json";

const AuthQueue = () => {
  const route = useGetQueueRoute();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(route);
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, route]);

  return (
    <Container
      maxWidth="xs"
      sx={{
        minHeight: "100vh", // full screen height
        display: "flex", // flexbox on container
        justifyContent: "center", // center vertically
        alignItems: "center", // center horizontally
      }}
    >
      <Stack alignItems="center">
        <Typography variant="h5" fontWeight={700}>
          Gathering your information...
        </Typography>
        <Lottie animationData={medicalClipboard} loop autoPlay />
      </Stack>
    </Container>
  );
};

export default AuthQueue;
